import { Button } from "antd";
import { Upload, type UploadRequestOptions } from "zhihao-ui-react";

export interface TradeOrderRemarkAttachmentProps {
    fileName?: string;
    filePath?: string;
    onUpload: (options: UploadRequestOptions) => void;
    onRemove: () => void;
    onPreview: () => void;
}

/** 复刻旧 Vue SingleUpload：未上传显示图标上传，已上传显示查看/下载和删除。 */
export function TradeOrderRemarkAttachment({
    fileName,
    filePath,
    onUpload,
    onRemove,
    onPreview
}: TradeOrderRemarkAttachmentProps) {
    const hasFile = Boolean(fileName);

    return (
        <Upload
            action="#"
            aria-label="备注附件"
            className="trade-order-remark-attachment"
            httpRequest={options => onUpload(options)}
            limit={1}
            showFileList={false}
        >
            {hasFile ? (
                <span className="trade-order-remark-attachment__uploaded">
                    <Button
                        aria-label="查看/下载备注附件"
                        className="trade-order-remark-attachment__link"
                        htmlType="button"
                        type="link"
                        onClick={event => {
                            event.stopPropagation();
                            if (filePath) onPreview();
                        }}
                    >
                        查看/下载
                    </Button>
                    <span
                        aria-label="删除附件"
                        className="iconfont icon-close trade-order-remark-attachment__remove"
                        role="button"
                        tabIndex={0}
                        onClick={event => {
                            event.stopPropagation();
                            onRemove();
                        }}
                        onKeyDown={event => {
                            if (event.key === "Enter" || event.key === " ") onRemove();
                        }}
                    />
                </span>
            ) : (
                <Button className="trade-order-remark-attachment__link" htmlType="button" type="link">
                    <span aria-hidden="true" className="iconfont icon-Frame-14 trade-order-remark-attachment__upload-icon" />
                    上传
                </Button>
            )}
        </Upload>
    );
}
